import CheckoutContainer from './checkout_container.jsx';

export default CheckoutContainer;


// WEBPACK FOOTER //
// ./src/components/Checkout/index.jsx